// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-84219a41] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget--list[data-v-84219a41] {
  width: var(--widget-full-width, 100%);
}
.widgets--list.icon-loading[data-v-84219a41] {
  min-height: 44px;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-6233f030] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/* stylelint-disable-next-line scss/at-import-partial-extension */
/**
 * Styles are extracted to extract scss to dist folder, too.
 */
li.task-list-item > ul[data-v-6233f030],
li.task-list-item > ol[data-v-6233f030],
li.task-list-item > li[data-v-6233f030],
li.task-list-item > blockquote[data-v-6233f030],
li.task-list-item > pre[data-v-6233f030] {
  margin-inline-start: 15px;
  margin-block-end: 0;
}
.rich-text--wrapper[data-v-6233f030] {
  word-break: break-word;
  line-height: 1.5;
}
.rich-text--wrapper .rich-text--fallback[data-v-6233f030], .rich-text--wrapper .rich-text-component[data-v-6233f030] {
  display: inline;
}
.rich-text--wrapper .rich-text--external-link[data-v-6233f030] {
  text-decoration: underline;
}
.rich-text--wrapper .rich-text--external-link[data-v-6233f030]:after {
  content: " ↗";
}
.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-6233f030] {
  list-style: decimal;
}
.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-6233f030] {
  list-style: initial;
}
.rich-text--wrapper .rich-text--list-item[data-v-6233f030] {
  white-space: initial;
  color: var(--color-text-light);
  padding: initial;
  margin-left: 20px;
}
.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-6233f030] {
  list-style: none;
  white-space: initial;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-6233f030] {
  min-height: initial;
}
.rich-text--wrapper .rich-text--strong[data-v-6233f030] {
  white-space: initial;
  font-weight: bold;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--italic[data-v-6233f030] {
  white-space: initial;
  font-style: italic;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--heading[data-v-6233f030] {
  white-space: initial;
  font-size: initial;
  color: var(--color-text-light);
  margin-bottom: 5px;
  margin-top: 5px;
  font-weight: bold;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-6233f030] {
  font-size: 20px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-6233f030] {
  font-size: 19px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-6233f030] {
  font-size: 18px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-6233f030] {
  font-size: 17px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-6233f030] {
  font-size: 16px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-6233f030] {
  font-size: 15px;
}
.rich-text--wrapper .rich-text--hr[data-v-6233f030] {
  border-top: 1px solid var(--color-border-dark);
  border-bottom: 0;
}
.rich-text--wrapper .rich-text--pre[data-v-6233f030] {
  border: 1px solid var(--color-border-dark);
  background-color: var(--color-background-dark);
  padding: 5px;
}
.rich-text--wrapper .rich-text--code[data-v-6233f030] {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper .rich-text--blockquote[data-v-6233f030] {
  border-left: 3px solid var(--color-border-dark);
  padding-left: 5px;
}
.rich-text--wrapper .rich-text--table[data-v-6233f030] {
  border-collapse: collapse;
}
.rich-text--wrapper .rich-text--table thead tr th[data-v-6233f030] {
  border: 1px solid var(--color-border-dark);
  font-weight: bold;
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr td[data-v-6233f030] {
  border: 1px solid var(--color-border-dark);
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr[data-v-6233f030]:nth-child(even) {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper-markdown div > *[data-v-6233f030]:first-child,
.rich-text--wrapper-markdown blockquote > *[data-v-6233f030]:first-child {
  margin-top: 0 !important;
}
.rich-text--wrapper-markdown div > *[data-v-6233f030]:last-child,
.rich-text--wrapper-markdown blockquote > *[data-v-6233f030]:last-child {
  margin-bottom: 0 !important;
}
.rich-text--wrapper-markdown h1[data-v-6233f030], .rich-text--wrapper-markdown h2[data-v-6233f030], .rich-text--wrapper-markdown h3[data-v-6233f030], .rich-text--wrapper-markdown h4[data-v-6233f030], .rich-text--wrapper-markdown h5[data-v-6233f030], .rich-text--wrapper-markdown h6[data-v-6233f030], .rich-text--wrapper-markdown p[data-v-6233f030], .rich-text--wrapper-markdown ul[data-v-6233f030], .rich-text--wrapper-markdown ol[data-v-6233f030], .rich-text--wrapper-markdown blockquote[data-v-6233f030], .rich-text--wrapper-markdown pre[data-v-6233f030] {
  margin-top: 0;
  margin-bottom: 1em;
}
.rich-text--wrapper-markdown h1[data-v-6233f030], .rich-text--wrapper-markdown h2[data-v-6233f030], .rich-text--wrapper-markdown h3[data-v-6233f030], .rich-text--wrapper-markdown h4[data-v-6233f030], .rich-text--wrapper-markdown h5[data-v-6233f030], .rich-text--wrapper-markdown h6[data-v-6233f030] {
  font-weight: bold;
}
.rich-text--wrapper-markdown h1[data-v-6233f030] {
  font-size: 30px;
}
.rich-text--wrapper-markdown ul[data-v-6233f030], .rich-text--wrapper-markdown ol[data-v-6233f030] {
  padding-left: 15px;
}
.rich-text--wrapper-markdown ul[data-v-6233f030] {
  list-style-type: disc;
}
.rich-text--wrapper-markdown ul.contains-task-list[data-v-6233f030] {
  list-style-type: none;
  padding: 0;
}
.rich-text--wrapper-markdown table[data-v-6233f030] {
  border-collapse: collapse;
  border: 2px solid var(--color-border-maxcontrast);
}
.rich-text--wrapper-markdown table th[data-v-6233f030],
.rich-text--wrapper-markdown table td[data-v-6233f030] {
  padding: var(--default-grid-baseline);
  border: 1px solid var(--color-border-maxcontrast);
}
.rich-text--wrapper-markdown table th[data-v-6233f030]:first-child,
.rich-text--wrapper-markdown table td[data-v-6233f030]:first-child {
  border-left: 0;
}
.rich-text--wrapper-markdown table th[data-v-6233f030]:last-child,
.rich-text--wrapper-markdown table td[data-v-6233f030]:last-child {
  border-right: 0;
}
.rich-text--wrapper-markdown table tr:first-child th[data-v-6233f030] {
  border-top: 0;
}
.rich-text--wrapper-markdown table tr:last-child td[data-v-6233f030] {
  border-bottom: 0;
}
.rich-text--wrapper-markdown blockquote[data-v-6233f030] {
  padding-left: 13px;
  border-left: 2px solid var(--color-border-dark);
  color: var(--color-text-lighter);
}
a[data-v-6233f030]:not(.rich-text--component) {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRichText-Cdp_2wEm.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,iEAAiE;AACjE;;EAEE;AACF;;;;;EAKE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE,8CAA8C;AAChD;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;AACA;;EAEE,qCAAqC;EACrC,iDAAiD;AACnD;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-84219a41] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget--list[data-v-84219a41] {\n  width: var(--widget-full-width, 100%);\n}\n.widgets--list.icon-loading[data-v-84219a41] {\n  min-height: 44px;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-6233f030] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/* stylelint-disable-next-line scss/at-import-partial-extension */\n/**\n * Styles are extracted to extract scss to dist folder, too.\n */\nli.task-list-item > ul[data-v-6233f030],\nli.task-list-item > ol[data-v-6233f030],\nli.task-list-item > li[data-v-6233f030],\nli.task-list-item > blockquote[data-v-6233f030],\nli.task-list-item > pre[data-v-6233f030] {\n  margin-inline-start: 15px;\n  margin-block-end: 0;\n}\n.rich-text--wrapper[data-v-6233f030] {\n  word-break: break-word;\n  line-height: 1.5;\n}\n.rich-text--wrapper .rich-text--fallback[data-v-6233f030], .rich-text--wrapper .rich-text-component[data-v-6233f030] {\n  display: inline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-6233f030] {\n  text-decoration: underline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-6233f030]:after {\n  content: \" ↗\";\n}\n.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-6233f030] {\n  list-style: decimal;\n}\n.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-6233f030] {\n  list-style: initial;\n}\n.rich-text--wrapper .rich-text--list-item[data-v-6233f030] {\n  white-space: initial;\n  color: var(--color-text-light);\n  padding: initial;\n  margin-left: 20px;\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-6233f030] {\n  list-style: none;\n  white-space: initial;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-6233f030] {\n  min-height: initial;\n}\n.rich-text--wrapper .rich-text--strong[data-v-6233f030] {\n  white-space: initial;\n  font-weight: bold;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--italic[data-v-6233f030] {\n  white-space: initial;\n  font-style: italic;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--heading[data-v-6233f030] {\n  white-space: initial;\n  font-size: initial;\n  color: var(--color-text-light);\n  margin-bottom: 5px;\n  margin-top: 5px;\n  font-weight: bold;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-6233f030] {\n  font-size: 20px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-6233f030] {\n  font-size: 19px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-6233f030] {\n  font-size: 18px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-6233f030] {\n  font-size: 17px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-6233f030] {\n  font-size: 16px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-6233f030] {\n  font-size: 15px;\n}\n.rich-text--wrapper .rich-text--hr[data-v-6233f030] {\n  border-top: 1px solid var(--color-border-dark);\n  border-bottom: 0;\n}\n.rich-text--wrapper .rich-text--pre[data-v-6233f030] {\n  border: 1px solid var(--color-border-dark);\n  background-color: var(--color-background-dark);\n  padding: 5px;\n}\n.rich-text--wrapper .rich-text--code[data-v-6233f030] {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper .rich-text--blockquote[data-v-6233f030] {\n  border-left: 3px solid var(--color-border-dark);\n  padding-left: 5px;\n}\n.rich-text--wrapper .rich-text--table[data-v-6233f030] {\n  border-collapse: collapse;\n}\n.rich-text--wrapper .rich-text--table thead tr th[data-v-6233f030] {\n  border: 1px solid var(--color-border-dark);\n  font-weight: bold;\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr td[data-v-6233f030] {\n  border: 1px solid var(--color-border-dark);\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr[data-v-6233f030]:nth-child(even) {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper-markdown div > *[data-v-6233f030]:first-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-6233f030]:first-child {\n  margin-top: 0 !important;\n}\n.rich-text--wrapper-markdown div > *[data-v-6233f030]:last-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-6233f030]:last-child {\n  margin-bottom: 0 !important;\n}\n.rich-text--wrapper-markdown h1[data-v-6233f030], .rich-text--wrapper-markdown h2[data-v-6233f030], .rich-text--wrapper-markdown h3[data-v-6233f030], .rich-text--wrapper-markdown h4[data-v-6233f030], .rich-text--wrapper-markdown h5[data-v-6233f030], .rich-text--wrapper-markdown h6[data-v-6233f030], .rich-text--wrapper-markdown p[data-v-6233f030], .rich-text--wrapper-markdown ul[data-v-6233f030], .rich-text--wrapper-markdown ol[data-v-6233f030], .rich-text--wrapper-markdown blockquote[data-v-6233f030], .rich-text--wrapper-markdown pre[data-v-6233f030] {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n.rich-text--wrapper-markdown h1[data-v-6233f030], .rich-text--wrapper-markdown h2[data-v-6233f030], .rich-text--wrapper-markdown h3[data-v-6233f030], .rich-text--wrapper-markdown h4[data-v-6233f030], .rich-text--wrapper-markdown h5[data-v-6233f030], .rich-text--wrapper-markdown h6[data-v-6233f030] {\n  font-weight: bold;\n}\n.rich-text--wrapper-markdown h1[data-v-6233f030] {\n  font-size: 30px;\n}\n.rich-text--wrapper-markdown ul[data-v-6233f030], .rich-text--wrapper-markdown ol[data-v-6233f030] {\n  padding-left: 15px;\n}\n.rich-text--wrapper-markdown ul[data-v-6233f030] {\n  list-style-type: disc;\n}\n.rich-text--wrapper-markdown ul.contains-task-list[data-v-6233f030] {\n  list-style-type: none;\n  padding: 0;\n}\n.rich-text--wrapper-markdown table[data-v-6233f030] {\n  border-collapse: collapse;\n  border: 2px solid var(--color-border-maxcontrast);\n}\n.rich-text--wrapper-markdown table th[data-v-6233f030],\n.rich-text--wrapper-markdown table td[data-v-6233f030] {\n  padding: var(--default-grid-baseline);\n  border: 1px solid var(--color-border-maxcontrast);\n}\n.rich-text--wrapper-markdown table th[data-v-6233f030]:first-child,\n.rich-text--wrapper-markdown table td[data-v-6233f030]:first-child {\n  border-left: 0;\n}\n.rich-text--wrapper-markdown table th[data-v-6233f030]:last-child,\n.rich-text--wrapper-markdown table td[data-v-6233f030]:last-child {\n  border-right: 0;\n}\n.rich-text--wrapper-markdown table tr:first-child th[data-v-6233f030] {\n  border-top: 0;\n}\n.rich-text--wrapper-markdown table tr:last-child td[data-v-6233f030] {\n  border-bottom: 0;\n}\n.rich-text--wrapper-markdown blockquote[data-v-6233f030] {\n  padding-left: 13px;\n  border-left: 2px solid var(--color-border-dark);\n  color: var(--color-text-lighter);\n}\na[data-v-6233f030]:not(.rich-text--component) {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
